module.exports = __webpack_public_path__ + "static/img/scenery-03.a263107.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album/scenery-03.jpg
// module id = 4OBR
// module chunks = 0